// Copyright (c) 2021 David Chan
//
// This software is released under the MIT License.
// https://opensource.org/licenses/MIT

import { Box, Container, Text } from '@mantine/core';

export default function Footer(props) {
    var start = new Date();
    var current_year = start ? start.getFullYear(0).toString() : '2021';

    return (
        <Box 
            component="footer" 
            role="contentinfo" 
            style={{ 
                borderTop: '1px solid #e9ecef', 
                backgroundColor: '#f8f9fa',
                marginTop: 'auto'
            }}
            py="md"
        >
            <Container size="xl" px="md">
                <Text 
                    size="sm" 
                    c="dimmed"
                    ta="center"
                >
                    &copy; {current_year} Paul Chan
                </Text>
            </Container>
        </Box>
    );
}
